@if (saasFeaturesLoaded$ | async) {
    @if (hasLenderDashboardFeature$ | async) {
        <app-thoughtspot-liveboard [liveboardId]="liveboardId()"></app-thoughtspot-liveboard>
    } @else {
        <app-dashboard [lenderStatistics]="lenderStatistics$ | async"
                       [formattedStatistics]="formattedStatistics$ | async">
        </app-dashboard>
    }
}
